$(document).ready(function () {
  $('#public-login').on('click touch', function (e) {
    e.stopPropagation();

    $('.tooltips-box').show();
  });

  $('.tooltips-group').on('click touch', function (e) {
    e.stopPropagation();   
    $('.fil-icon .tip-title').show();
      if($(window).height() - $('.fil-icon .tip-title .tooltips-content')[0].getBoundingClientRect().bottom < 0){
        $('html, body').animate({ scrollTop: 700 }, 500)
      }
  });

  $('#cancelTooltips').on('click touch', function (e) {
    if (e && e.preventDefault) {
      //not IE explorer
      e.preventDefault();
    } else {
      //IE explorer(below IE11)
      window.event.returnValue = false;
    }
    $('.tooltips-box').hide();
    return false;
  });

  $('#cancelGroupTooltips').on('click touch', function (e) {
    if (e && e.preventDefault) {
      //not IE explorer
      e.preventDefault();
    } else {
      //IE explorer(below IE11)
      window.event.returnValue = false;
    }
    $('.fil-icon .tip-title').hide();
    return false;
  });

  $('#confirmTooltips').on('click touch', function (e) {
    if (e && e.preventDefault) {
      //not IE explorer
      e.preventDefault();
    } else {
      //IE explorer(below IE11)
      window.event.returnValue = false;
    }
    $('.tooltips-box').hide();
    $('.fil-icon .tip-title').hide();
    return false;
  });

  $('#confirmGroupTooltips').on('click touch', function (e) {
    if (e && e.preventDefault) {
      //not IE explorer
      e.preventDefault();
    } else {
      //IE explorer(below IE11)
      window.event.returnValue = false;
    }
    $('.fil-icon .tip-title').hide();
    return false;
  });


  $('.camc-login').on('click touch', function (e) {
    e.stopPropagation();
    $('.medium-tooltips-box').show();
  });

  $('.tooltips-group').parent().parents().on('click touch', function () {
    $('.fil-icon .tip-title').hide();
  });

  $('.tooltips-box').parent().parents().on('click touch', function () {
    $('.tooltips-box').hide();
  });

  $('.medium-tooltips-box').parent().parents().on('click touch', function () {
    $('.medium-tooltips-box').hide();
  });

  $('#cancelMediumTooltips').on('click touch', function (e) {
    if (e && e.preventDefault) {
      //非IE浏览器
      e.preventDefault();
    } else {
      //IE浏览器(IE11以下)
      window.event.returnValue = false;
    }
    $('.medium-tooltips-box').hide();
    return false;
  });

  function windowResizingEvent() {
    if (Foundation.MediaQuery.atLeast('large')) {
      let mediumTooltips = $('.medium-tooltips-box').not(':hidden');
      if (mediumTooltips && mediumTooltips.length > 0) {
        $('.medium-tooltips-box').hide();
      }
    }

  }
  $(window).on('resize', windowResizingEvent);
});